export function Privacy() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
      <h1 className="text-3xl font-bold tracking-tight text-text-primary">Privacy Policy</h1>
      <p className="mt-2 text-sm text-text-muted">Last updated: {new Date().getFullYear()}</p>
      <div className="prose-invert mt-8 space-y-6 text-sm leading-relaxed text-text-secondary">
        <Section title="Overview">
          Visiward helps you understand how your website and brand may be represented in
          AI-generated answers. This policy explains what we collect and how we use it. This is an
          MVP document and not legal advice.
        </Section>
        <Section title="Information we collect">
          When you run an analysis we process the website URL you provide and publicly available
          metadata from that page. If you create an account, we store your email, display name, and
          the projects and reports you save. Anonymous analyses are stored temporarily and expire
          automatically.
        </Section>
        <Section title="How we use information">
          We use your information to run analyses, save your reports, enforce fair-use limits, and
          improve the product. We do not sell your personal information.
        </Section>
        <Section title="Website content">
          Content we inspect from your website is treated as untrusted input and used only to infer
          your brand and generate analysis prompts. We never execute scripts from inspected pages.
        </Section>
        <Section title="Data retention">
          Anonymous results expire after 24 hours. Registered users’ saved history is retained for
          the duration configured for the launch-free plan.
        </Section>
        <Section title="Contact">
          For privacy questions, use the contact form. We’ll respond as soon as we can.
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="mb-2 text-lg font-semibold text-text-primary">{title}</h2>
      <p>{children}</p>
    </section>
  );
}
